<template>
        <card>
           <template slot="header">
              <h3 class="card-title">Leave Management</h3>
           </template>
           <div class="row">
              <div class="col-md-8">
                 <nav class="row">
                    <ol class="breadcrumb arr-right bg-breadcrum">
                       <li class="breadcrumb-item">
                          <router-link to="dashboard"><i class="fa fa-home"></i>&nbsp;Dashboard</router-link>
                       </li>
                       <li class="breadcrumb-item">
                          <router-link to="absenceleave">Leave & Absences Record</router-link>
                       </li>
                       <li class="breadcrumb-item active">Employee Leave Credits</li>
                    </ol>
                 </nav>
              </div>
              <div class="col-md-4">
                 <button class="btn btn-primary float-right" v-b-modal.add-new-item><i class="fa fa-plus"></i>&nbsp;Register Leave Credits</button>
              </div>
           </div>
           <hr style="margin-top:-10px"/>
           <div class="col-md-12">
              <div class="row">
                 <div class="col-md-9">
                    <p><i class="fa fa-search"></i> Search Employee</p>
                    <input type="test" v-model="search" class="form-control" placeholder="Search..."> 
                 </div>
                 <div class="col-md-1">
                    <div class="form-group">
                       <p><i class="fa fa-sort-numeric-asc"></i>&nbsp;Display</p>
                       <select v-model="page_limit" class="form-control" required>
                          <option value="">Default</option>
                          <option value="2">2</option>
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                          <option value="500">500</option>
                       </select>
                    </div>
                 </div>
                 <div class="col-md-2">
                    <div class="form-group">
                       <p><i class="fa fa-sort-amount-asc"></i>&nbsp;Order by </p>
                       <select v-model="order_by" class="form-control" required>
                          <option value="">Default</option>
                          <option value="1">ASC</option>
                          <option value="-1">DESC</option>
                       </select>
                    </div>
                 </div>
              </div>
           </div>
           <hr>
           <div class="table-responsive ">
              <table class="table table-striped table-hover " v-loading="loading">
                 <thead>
                    <tr>
                       <th width="50">#</th>
                       <th width="380">Employee Name</th>
                       <th width="180"></th>
                       <th width="180"></th>
                       <th width="180"></th>
                       <th width="180"></th>
                       <th width="180"></th>
                       <th width="170"></th>
                       <th width="160">Action</th>
                    </tr>
                 </thead>
                 <tbody>
                    <tr v-for="item,index in computedLeave">
                       <template v-if="item === 'no data found'">
                          <td colspan="100%">
                             <h4>  <i class="fa fa-database"></i> Empty Records ...</h4>
                          </td>
                       </template>
                       <template v-else>
                          <!-- <td>{{index + 1}}</td> -->
                          <td>{{index + 1}}</td>
                          <td><b>{{item.full_name | capitalize}}</b></td>
                          <td>Credit Balance <span class="badge badge-pill badge-success m-size">{{item.leave_credit_balance}}</span></td>
                          <td><b></b>Leave Used <span class="badge badge-pill badge-warning m-size">{{item.leave_credit_used}}</span></td>
                          <td><b></b>Bereavement <span class="badge badge-pill badge-danger m-size">{{item.leave_credit_bereavement}}</span></td>
                          <td><b></b>Solo Parent <span class="badge badge-pill badge-primary m-size">{{item.leave_credit_solo_parents}}</span></td>
                          <td><b></b>Maternity <span class="badge badge-pill badge-secondary m-size">{{item.leave_credit_maternity}}</span></td>
                          <td><b></b>Paternity <span class="badge badge-pill badge-info m-size">{{item.leave_credit_paternity}}</span></td>
                          <td>
                             <a href="#" @click="get_update_item(item)" class="link-credits-update" v-b-modal.update-leave-credit><u><i class="fa fa-pencil"></i>Update</u></a> 
                          </td>
                       </template>
                    </tr>
                 </tbody>
              </table>
           </div>
           <!-- MODAL FOR ADD NEW ITEM -->
           <b-modal id="add-new-item" ref="add-new-credits"  size="l"   hide-footer>
              <h4 class="c-padding">Register Employee Leave Credits</h4>
              <div class="form-group">
                 <label>Select Employee:</label>
                 <select class="form-control" v-model="employee_id" required>
                    <option value="">-- Select Employee --</option>
                    <option v-for="emp in employee_item" v-bind:value="emp.id">{{emp.full_name}}</option>
                 </select>
              </div>
              <div class="form-group">
                 <label>Leave Credits Balance:</label>
                 <input type="text"  v-mask="['#']" class="form-control" v-model="leave_credit_balance">
              </div>
              <div class="form-group">
                 <label>Leave Credits Used:</label>
                 <input type="text" v-mask="['#']" class="form-control" v-model="leave_credit_used">
              </div>
              <div class="form-group">
                 <button class="btn btn-info float-right" @click="register_leave_credits"><i class="fa fa-save"></i> Register Leave Credits</button>
              </div>
              <br/><br/><br/>
           </b-modal>
             <!-- UPDATE LEAVE  -->
             <b-modal id="update-leave-credit" ref="leave-credits-update"  size="xl"   hide-footer>
                <h4 class="c-padding">Update Leave Credits</h4>
                <div class="form-group">
                    <h4><b>{{selected_user.full_name | capitalize}}</b></h4>
                    {{selected_user.employee_id}}
                </div>
                <div class="row">
                    <div class="col-6">
                        <div class="form-group">
                            <label>Leave Credits Balance:</label>
                            <input type="text"  v-mask="['##']" class="form-control" v-model="selected_user.leave_credit_balance" readonly>
                         </div>
                         <div class="form-group">
                            <label>Leave Credits Used:</label>
                            <input type="text" v-mask="['##']" class="form-control" v-model="selected_user.leave_credit_used">
                         </div>
                         <div class="form-group">
                                <label>Bereavement:</label>
                                <input type="text" v-mask="['##']" class="form-control" v-model="selected_user.leave_credit_bereavement">
                             </div>
                    </div>
                    <div class="col-6">
                          <div class="form-group">
                             <label>Solo Parent:</label>
                             <input type="text" v-mask="['##']" class="form-control" v-model="selected_user.leave_credit_solo_parents">
                          </div>
                          <div class="form-group">
                             <label>Maternity:</label>
                             <input type="text" v-mask="['##']" class="form-control" v-model="selected_user.leave_credit_maternity">
                          </div>
                          <div class="form-group">
                             <label>Paternity:</label>
                             <input type="text" v-mask="['##']" class="form-control" v-model="selected_user.leave_credit_paternity">
                          </div>
                    </div>
                </div>
                <div class="form-group">
                   <button class="btn btn-info float-right" @click="update_leave_credits"><i class="fa fa-save"></i> Update Leave Credits</button>
                </div>
                <br/><br/><br/>
             </b-modal>
        </card>
     </template>

<script>
/* eslint-disable */
import Card from 'src/components/UIComponents/Cards/Card.vue'
export default {
    components: {
        Card,
    },

    data(){
        return{
            items:[],
            employee_item:[],

            employee_id:'',
            leave_credit_used:'',
            leave_credit_balance:'',

            leave_status:'',
            search:'',
            order_by:'',
         //pagination
            page_limit:'',
            start_page:1,
            loading:true, 
        //Indicator
            display_indicator:'',
        //error handler
            error_handler:[],
         // selected id
            selected_user: '',    

        }
    },

     mounted: function() {
        this.get_employees()
        this.no_leave_credits()
    },

    methods:{
        update_leave_credits(){
            console.log('reponse => emp_id :',this.selected_user.emp_id)
             axios   
                 .post('api/leave/credits/update/' + this.selected_user.id,
                     { 
                        'employee_id': this.selected_user.emp_id,
                        'leave_credit_balance':this.selected_user.leave_credit_balance,
                        'leave_credit_used':this.selected_user.leave_credit_used,

                         'leave_credit_bereavement':this.selected_user.leave_credit_bereavement,
                         'leave_credit_solo_parents':this.selected_user.leave_credit_solo_parents,
                         'leave_credit_maternity':this.selected_user.leave_credit_maternity,
                         'leave_credit_paternity':this.selected_user.leave_credit_paternity
                     }
                 )
                 .then(resp => {
                     if(resp.data.response == 'success'){
                        this.$swal('Success',resp.data.message, 'success');
                        this.$refs['leave-credits-update'].hide();
                        this.get_employees()
                     }else if(resp.data.response == 'error'){
                        this.$swal('Opps',resp.data.message, 'error');
                     }
                 })
                 .catch(error => {
                     console.log(error)
                 })
            
        },
        register_leave_credits(e){
            e.preventDefault();
            this.$swal({
                title: 'Are you sure?',
                text: 'Do you want to register leave credits.',
                type: 'warning',
                showCancelButton: true,
                showCloseButton: false,
                })
                .then((isConfirm) => {
                if (isConfirm === true) {
                    axios
                        .post('api/register/credits',{
                                'employee_id':this.employee_id,
                                'leave_credit_balance':this.leave_credit_balance,
                                'leave_credit_used':this.leave_credit_used
                        })
                        .then(resp => {
        
                                if(resp.data.response == 'error'){
                                    this.$swal('Opps',resp.data.message, 'error');
                                }else if(resp.data.response == 'success'){
                                    this.$refs['add-new-credits'].hide();
                                    this.$swal({
                                        type: 'success',
                                        title: 'Success',
                                        text: 'Employee leave credits, Has been Successfully Register.',
                                        showConfirmButton: false,
                                        timer: 2000
                                    })
                                    this.get_employees()
                                    this.no_leave_credits()
                                    this.leave_credit_used = ''
                                    this.leave_credit_balance = ''
                                }
                        })      
                        .catch(error => {
                                console.log(error);
                        });
                   }
                });
        },

        get_update_item(item){
            this.selected_user = item
        },
        getCurentUser() {
            axios.get('api/user')
                  .then(response => {
                    let users = response.data;
                    if (users.role_id != 5) {
                          this.$router.push({
                          name: 'Login-Layout'
                      })
                    }
                  })
                .catch(error => {  console.log(error.response)  });
         },
        get_employees(){ 
            axios.get('api/leavecredits')
                 .then(response => {
                      this.items = response.data; 
                      this.display_indicator = 2;
                      this.loading = false;
                 })  
                 .catch(error => { 
                     console.log(error.response)  
                     this.display_indicator = 1;
                 });
        },
        no_leave_credits(){ 
            axios.get('api/employee/nocredits')
                 .then(response => {
                      this.employee_item = response.data; 
                      this.display_indicator = 2;
                 })  
                 .catch(error => { 
                     console.log(error.response)  
                     this.display_indicator = 1;
                 });
        },
    },
    computed:{
         // PAGINATION
           offset() {
                  return ((this.start_page - 1) * this.page_limit);
            },
     
            limit() {
                  return ((this.offset + this.page_limit));
            }, 

            total_record(){
                 return this.items.length
            },

             numOfPages(){
                  return Math.ceil(this.items.length / this.page_limit);
            },  
      
          computedLeave(){
            
             let filtered = this.items
              if(filtered.length > 0){
                // SEARCH BY EMPLOYEE FULLNAME
                if(this.search) {
                   filtered = filtered.filter(
                    item => item.full_name.toLowerCase().indexOf(this.search) > -1
                   );
                  return filtered
               } 
               // SORTING NUMBER OF DISPLAY
               if(this.page_limit){
                 filtered =  filtered.slice(this.offset, this.limit);
                   return filtered
                 }
              // ORDER BY ASC AND DESC COMBOBOX
               if(this.order_by){
                    filtered = filtered.slice(0).sort((a, b) => a.full_name < b.full_name ? this.order_by : -this.order_by )
                    return filtered
                }   
              }
          return filtered   
        }
    }
}
</script>
 <style>
.fa-update{
    color:#07b22c;
    font-size:19px;
}
.bg-breadcrum{
    background:#fff;
}

.l-size{
    font-size: 20px;
}
.c-padding{
    padding:-10px; 
}

.link-credits-update{
        font-size: 16px;
        font-weight: 500;
        line-height: 1.1;
    }
  
    /* @media (min-width: 576px) {
    .modal-dialog {
        margin-top: -100px !important;
    }
   } */
</style>   
 
    


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-leave-management/todo-leave-credits.vue